// extracted by mini-css-extract-plugin
module.exports = {"contactNameIcon":"index-module_contactNameIcon_2IHgN"};